import { render, staticRenderFns } from "./NeoparentMessageConfiguration.vue?vue&type=template&id=406163a3&scoped=true"
import script from "./NeoparentMessageConfiguration.vue?vue&type=script&lang=js"
export * from "./NeoparentMessageConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406163a3",
  null
  
)

export default component.exports